<template>
  <aside v-if="available" class="app-update-banner" role="status">
    <span>{{ $t('APP_UPDATE.MESSAGE') }}</span>
    <button
      type="button"
      :disabled="refreshing"
      :aria-busy="refreshing"
      @click="refresh"
    >
      {{ $t('APP_UPDATE.REFRESH') }}
    </button>
  </aside>
</template>

<script>
import { startAppUpdateMonitor } from 'dashboard/helper/appUpdateMonitor';

export default {
  name: 'AppUpdateBanner',
  data() {
    return { available: false, refreshing: false, stopMonitor: null };
  },
  mounted() {
    this.stopMonitor = startAppUpdateMonitor({
      buildVersion: process.env.OTELLO_BUILD_REVISION,
      onUpdate: (available) => {
        this.available = available;
      },
    });
  },
  beforeUnmount() {
    this.stopMonitor?.();
  },
  methods: {
    async refresh() {
      if (this.refreshing) return;
      this.refreshing = true;
      const ready = await this.stopMonitor?.check?.();
      if (ready) {
        window.location.reload();
      } else {
        this.refreshing = false;
      }
    },
  },
};
</script>

<style scoped>
.app-update-banner {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: max-content;
  max-width: calc(100% - 2rem);
  padding: 0.85rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  color: #172033;
  box-shadow: 0 4px 20px #0002;
  font-size: 0.875rem;
}
.app-update-banner button {
  flex-shrink: 0;
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  background: #1d4ed8;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.app-update-banner button:disabled {
  opacity: 0.6;
  cursor: wait;
}
.app-update-banner button:focus-visible {
  outline: 2px solid #172033;
  outline-offset: 3px;
}
</style>
